import { FC } from "react";
import { FacingFinGroup, Option } from "tm-shared/types";

import { PrimaryText } from "@/components/Typography/Styled";

import { StyledCheckbox } from "./Styled";

interface CheckboxFinGroupRowProps {
    finGroup: Option;
    checked: boolean;
    onChange: (product: FacingFinGroup, checked: boolean) => void;
}

export const CheckboxFinGroupRow: FC<CheckboxFinGroupRowProps> = ({
    finGroup,
    checked,
    onChange,
}) => {
    return (
        <StyledCheckbox
            checked={checked}
            onChange={(e) =>
                onChange(
                    {
                        finGroup: finGroup.value,
                        quantity: 1,
                    },
                    e.target.checked,
                )
            }
        >
            <PrimaryText fontSize={16}>{finGroup.label}</PrimaryText>
        </StyledCheckbox>
    );
};
